import React, { useState, useEffect } from 'react';
import { useShortURL } from './API/Api';
import { handleCopyClick, handleShareClick } from './js/utility';

const OfferModal = ({ selectedOffer, closeModal }) => {
    const Offer = selectedOffer;

    const click_url = Offer?.tracking_link;
    const payout_vc = Offer?.payout;

    const { shortURL, error, loading } = useShortURL(click_url);
    const [copyStatus, setCopyStatus] = useState(false);

    // Close modal if selectedOffer is null
    useEffect(() => {
        if (!Offer) {
            closeModal();
        }
    }, [Offer, closeModal]);

    return (
        <div className={`modal ${Offer ? 'show' : ''}`} style={{ display: Offer ? 'block' : 'none' }} tabIndex="-1" aria-labelledby="offerModalLabel" aria-hidden={!Offer}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="offerModalLabel">Offer #{Offer?.id}</h5>
                        <button type="button" className="btn-close" onClick={closeModal} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        {Offer && (
                          <>    
                            <div className="d-flex mb-3">
                                <div className="flex-shrink-0">
                                    <img className="img-fluid border rounded shadow" src={Offer.icon} alt={Offer.name} style={{ width: "150px" }} />
                                </div>
                                <div className="flex-grow-1 ms-3">
                                    <p>{Offer.name}</p>
                                    <small dangerouslySetInnerHTML={{ __html: coreTSW.convertToBadge('platformToLabel', Offer.platform, Offer) }}></small>                                    
                                </div>
                            </div>
                            <div className="alert alert-primary fade show" role="alert">
                                <h4 className="alert-heading">Task</h4>
                                <span>{Offer.conversion_instructions_short}</span>
                                {Offer.conversion_type === "cpe" && (
                                    <div>
                                        <hr/>
                                        {Offer.cpe_instructions.map((instruction) => (
                                            <div key={instruction.uuid} className="d-flex align-items-center mb-2">
                                                <div className="me-3">
                                                    <strong>{instruction.name}</strong>
                                                </div>
                                                <div className="ms-auto d-flex align-items-center">
                                                    <span className={`badge ${instruction.completed ? 'bg-success' : 'bg-secondary'}`}>
                                                        {instruction.completed ? "Completed" : `Incomplete (${instruction.percentage}%)`}
                                                    </span>
                                                    <span className="badge bg-warning ms-2">
                                                        +{instruction.payout} Coins
                                                    </span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>  
                          </>                                
                        )}                      
                    </div>
                    <div className="modal-footer">
                        <div className="w-100">
                            <a className="btn btn-warning w-100" href={click_url} target="_blank">
                                <i className="fas fa-coins fa-fw"></i> <i className="bi bi-plus m-0"></i> {payout_vc} 
                                <span className="d-none d-sm-inline">&nbsp;COIN(s)</span>
                            </a>
                        </div>
                    </div>
                    {shortURL && (
                        <div className="modal-footer">
                            <div className="row">
                                <div className="col-md-6 text-center">
                                    <img className="img-fluid border rounded bg-light p-1" src={`${shortURL}/qr`} alt="QR Code" style={{ width: '200px' }} /> 
                                </div>
                                <div className="col-md-6">
                                    <div className="btn-group w-100 mt-1 mb-1">
                                        <button className="btn btn-outline-secondary w-100" type="button" onClick={() => handleCopyClick(shortURL, setCopyStatus)}>
                                            {shortURL}
                                            <i className={`bi ${copyStatus ? 'bi-check-circle' : 'bi-clipboard'} ms-2`}></i>
                                        </button>
                                    </div>
                                    <a className="btn btn-outline-success w-100 mt-1 mb-1" href={`https://wa.me/?text=${encodeURIComponent(shortURL)}`} target="_blank">
                                        <i className="bi bi-whatsapp"></i>&nbsp;&nbsp;
                                        Share via WhatsApp
                                    </a>
                                    <button className="btn btn-outline-primary w-100 mt-1 mb-1" type="button" onClick={() => handleShareClick(Offer?.name, Offer?.name, shortURL)}>
                                        <i className="bi bi-share"></i>&nbsp;&nbsp;
                                        Share via Apps
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default OfferModal;
